import {
  IMMEDIATE_NURSE_CONSULT_SMS_LOCAL_STORAGE_KEY,
  MAX_SMS_RETRY_AFTER_MS,
  MAX_SMS_RETRY_COUNT,
} from '@/constants/immediateNurseConsultation';
import { useState } from 'react';

type UseSmsVerificationBlocked = {
  sendSmsRetryCount: number;
};

export const useSmsVerificationBlocked = ({ sendSmsRetryCount }: UseSmsVerificationBlocked) => {
  const [blocked, _] = useState(() => {
    const expiry = Number(localStorage.getItem(IMMEDIATE_NURSE_CONSULT_SMS_LOCAL_STORAGE_KEY) || 0);

    // If the expiry is relatively way too far ahead, we consider it blocked.
    const hasExceededThreshold = expiry - Date.now() > MAX_SMS_RETRY_AFTER_MS;

    // If the number of retries exceeds the allowable number, we consider it blocked.
    const hasExceededRetryCount = sendSmsRetryCount >= MAX_SMS_RETRY_COUNT;

    return hasExceededThreshold || hasExceededRetryCount;
  });

  return { blocked };
};
